import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

interface LoadingStateProps {
  /** Number of skeleton rows to show (default: 2) */
  readonly rows?: number;
  /** Show header skeleton (default: true) */
  readonly showHeader?: boolean;
  /** Additional className */
  readonly className?: string;
}

export const LoadingState = ({
  rows = 2,
  showHeader = true,
  className,
}: LoadingStateProps) => {
  return (
    <div className={cn('space-y-2 p-2', className)}>
      {showHeader && (
        <div className="flex items-center gap-2">
          <Skeleton className="h-8 w-8 rounded" />
          <div className="min-w-0 flex-1 space-y-1">
            <Skeleton className="h-3 w-24" />
            <Skeleton className="h-2 w-16" />
          </div>
        </div>
      )}
      <div className="space-y-1 pt-1">
        {Array.from({ length: rows }, (_, i) => (
          <Skeleton key={i} className="h-6 w-full rounded-sm" />
        ))}
      </div>
    </div>
  );
};
